<div class="solicitud-container container py-4">
  <h2 class="mb-4">Registro de Solicitud de Salud Irrecuperable</h2>
  <p class="text-muted mb-4">Funcionario Público</p>

  <form [formGroup]="form" (ngSubmit)="onContinuar()" class="solicitud-form">

    <!-- SECCIÓN 1: DATOS DEL SOLICITANTE -->
    <div class="card mb-4">
      <div class="card-header bg-primary text-white">
        <h5 class="mb-0">Datos del Solicitante</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-12 mb-12">
            <label class="form-label">RUT Solicitante <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="solicitanteRut"
              [class.is-invalid]="(submitted || f['solicitanteRut'].touched) && f['solicitanteRut'].errors"
              placeholder="12345678-9">
            <div class="invalid-feedback"
              *ngIf="(submitted || f['solicitanteRut'].touched) && f['solicitanteRut'].errors">
              RUT es requerido
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <label class="form-label">Correo Electrónico <span class="text-danger">*</span></label>
            <input type="email" class="form-control" formControlName="solicitanteCorreo"
              [class.is-invalid]="(submitted || f['solicitanteCorreo'].touched) && f['solicitanteCorreo'].errors"
              placeholder="correo@ejemplo.com">
            <div class="invalid-feedback"
              *ngIf="(submitted || f['solicitanteCorreo'].touched) && f['solicitanteCorreo'].errors">
              Correo válido es requerido
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <label class="form-label">Nombre <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="solicitanteNombre"
              [class.is-invalid]="(submitted || f['solicitanteNombre'].touched) && f['solicitanteNombre'].errors"
              placeholder="Nombre">
            <div class="invalid-feedback"
              *ngIf="(submitted || f['solicitanteNombre'].touched) && f['solicitanteNombre'].errors">
              Nombre es requerido
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <label class="form-label">Apellido Paterno <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="solicitanteApellidoPaterno"
              [class.is-invalid]="(submitted || f['solicitanteApellidoPaterno'].touched) && f['solicitanteApellidoPaterno'].errors"
              placeholder="Apellido Paterno">
            <div class="invalid-feedback"
              *ngIf="(submitted || f['solicitanteApellidoPaterno'].touched) && f['solicitanteApellidoPaterno'].errors">
              Apellido Paterno es requerido
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <label class="form-label">Apellido Materno <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="solicitanteApellidoMaterno"
              [class.is-invalid]="(submitted || f['solicitanteApellidoMaterno'].touched) && f['solicitanteApellidoMaterno'].errors"
              placeholder="Apellido Materno">
            <div class="invalid-feedback"
              *ngIf="(submitted || f['solicitanteApellidoMaterno'].touched) && f['solicitanteApellidoMaterno'].errors">
              Apellido Materno es requerido
            </div>
          </div>



          <div class="col-md-12 mb-3">
            <label class="form-label">Teléfono de Contacto <span class="text-danger">*</span></label>
            <input type="tel" class="form-control" formControlName="solicitanteTelefono"
              [class.is-invalid]="(submitted || f['solicitanteTelefono'].touched) && f['solicitanteTelefono'].errors"
              placeholder="+56 9 1234 5678">
            <small class="form-text text-muted d-block mt-1">
              <strong>Formato:</strong> Este número debe ser accesible en caso de requerir información
              <strong>Celular:</strong> (+569-XXXX-XXXX) | <strong>Fijo:</strong> (+562-XXXX-XXXX)
            </small>
            <div class="invalid-feedback"
              *ngIf="(submitted || f['solicitanteTelefono'].touched) && f['solicitanteTelefono'].errors">
              Teléfono es requerido
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- SECCIÓN 2: DATOS DE LA INSTITUCIÓN -->
    <div class="card mb-4">
      <div class="card-header bg-primary text-white">
        <h5 class="mb-0">Datos de la Institución</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6 mb-3">
            <label class="form-label">RUT de la Institución <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="institucionRut"
              [class.is-invalid]="(submitted || f['institucionRut'].touched) && f['institucionRut'].errors"
              placeholder="12345678-9">
            <div class="invalid-feedback"
              *ngIf="(submitted || f['institucionRut'].touched) && f['institucionRut'].errors">
              RUT de institución es requerido
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <label class="form-label">Nombre de la Institución <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="institucionNombre"
              [class.is-invalid]="(submitted || f['institucionNombre'].touched) && f['institucionNombre'].errors"
              placeholder="Nombre institución">
            <div class="invalid-feedback"
              *ngIf="(submitted || f['institucionNombre'].touched) && f['institucionNombre'].errors">
              Nombre de institución es requerido
            </div>
          </div>


          <div class="col-md-12 mb-3">
            <label class="form-label">Dirección <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="institucionDireccion"
              [class.is-invalid]="(submitted || f['institucionDireccion'].touched) && f['institucionDireccion'].errors"
              placeholder="Calle, número, piso">
            <div class="invalid-feedback"
              *ngIf="(submitted || f['institucionDireccion'].touched) && f['institucionDireccion'].errors">
              Dirección es requerida
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <label class="form-label">Región <span class="text-danger">*</span></label>
            <select class="form-control si-select" formControlName="institucionRegion"
              [class.is-invalid]="(submitted || f['institucionRegion'].touched) && f['institucionRegion'].errors">
              <option value="">-- Seleccione región --</option>
              <option *ngFor="let region of regiones" [value]="region.codigo">{{region.codigo}}.{{ region.nombre }}
              </option>
            </select>
            <div class="invalid-feedback"
              *ngIf="(submitted || f['institucionRegion'].touched) && f['institucionRegion'].errors">
              Región es requerida
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <label class="form-label">Comuna <span class="text-danger">*</span></label>
            <select class="form-control si-select" formControlName="institucionComuna"
              [class.is-invalid]="(submitted || f['institucionComuna'].touched) && f['institucionComuna'].errors"
              [disabled]="!f['institucionRegion'].value">
              <option value="">-- Seleccione comuna --</option>
              <option *ngFor="let comuna of institucionComunas" [value]="comuna.codigo">{{ comuna.codigo
                }}.{{comuna.nombre}}
              </option>
            </select>
            <div class="invalid-feedback"
              *ngIf="(submitted || f['institucionComuna'].touched) && f['institucionComuna'].errors">
              Comuna es requerida
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <label class="form-label">Nombre Completo del Jefe Superior del Servicio <span
                class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="jefeNombreCompleto"
              [class.is-invalid]="(submitted || f['jefeNombreCompleto'].touched) && f['jefeNombreCompleto'].errors"
              placeholder="Nombre completo">
            <div class="invalid-feedback"
              *ngIf="(submitted || f['jefeNombreCompleto'].touched) && f['jefeNombreCompleto'].errors">
              Nombre del jefe es requerido
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <label class="form-label">Correo de Notificación Institucional <span class="text-danger">*</span></label>
            <input type="email" class="form-control" formControlName="institucionCorreoNotificacion"
              [class.is-invalid]="(submitted || f['institucionCorreoNotificacion'].touched) && f['institucionCorreoNotificacion'].errors"
              placeholder="correo@institucion.cl">
            <div class="invalid-feedback"
              *ngIf="(submitted || f['institucionCorreoNotificacion'].touched) && f['institucionCorreoNotificacion'].errors">
              Correo válido es requerido
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- SECCIÓN 3: DATOS DEL FUNCIONARIO A EVALUAR -->
    <div class="card mb-4">
      <div class="card-header bg-primary text-white">
        <h5 class="mb-0">Datos del Funcionario a Evaluar</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-12 mb-12">
            <label class="form-label">RUT <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="funcionarioRut"
              [class.is-invalid]="(submitted || f['funcionarioRut'].touched) && f['funcionarioRut'].errors"
              placeholder="Rut">
            <div class="invalid-feedback"
              *ngIf="(submitted || f['funcionarioRut'].touched) && f['funcionarioRut'].errors">
              RUT es requerido
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <label class="form-label">Nombre <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="funcionarioNombre"
              [class.is-invalid]="(submitted || f['funcionarioNombre'].touched) && f['funcionarioNombre'].errors"
              placeholder="Nombre">
            <div class="invalid-feedback"
              *ngIf="(submitted || f['funcionarioNombre'].touched) && f['funcionarioNombre'].errors">
              Nombre es requerido
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <label class="form-label">Apellido Paterno <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="funcionarioApellidoPaterno"
              [class.is-invalid]="(submitted || f['funcionarioApellidoPaterno'].touched) && f['funcionarioApellidoPaterno'].errors"
              placeholder="Apellido paterno">
            <div class="invalid-feedback"
              *ngIf="(submitted || f['funcionarioApellidoPaterno'].touched) && f['funcionarioApellidoPaterno'].errors">
              Apellido paterno es requerido
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <label class="form-label">Apellido Materno <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="funcionarioApellidoMaterno"
              [class.is-invalid]="(submitted || f['funcionarioApellidoMaterno'].touched) && f['funcionarioApellidoMaterno'].errors"
              placeholder="Apellido materno">
            <div class="invalid-feedback"
              *ngIf="(submitted || f['funcionarioApellidoMaterno'].touched) && f['funcionarioApellidoMaterno'].errors">
              Apellido materno es requerido
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <label class="form-label">Fecha de Nacimiento <span class="text-danger">*</span></label>
            <input type="date" class="form-control" formControlName="funcionarioFechaNacimiento"
              [class.is-invalid]="(submitted || f['funcionarioFechaNacimiento'].touched) && f['funcionarioFechaNacimiento'].errors">
            <div class="invalid-feedback"
              *ngIf="(submitted || f['funcionarioFechaNacimiento'].touched) && f['funcionarioFechaNacimiento'].errors">
              <span *ngIf="f['funcionarioFechaNacimiento'].errors['futureDate']">La fecha de nacimiento no puede ser
                mayor a hoy</span>
              <span *ngIf="f['funcionarioFechaNacimiento'].errors['required']">Fecha de nacimiento es requerida</span>
            </div>
          </div>

          <div class="col-md-3 mb-3">
            <label class="form-label">Edad (Calculada)</label>
            <input type="text" class="form-control" formControlName="funcionarioEdad" readonly>
          </div>

          <div class="col-md-3 mb-3">
            <label class="form-label">Sexo <span class="text-danger">*</span></label>
            <select class="form-control si-select" formControlName="funcionarioSexo"
              [class.is-invalid]="(submitted || f['funcionarioSexo'].touched) && f['funcionarioSexo'].errors">
              <option value="">-- Seleccione --</option>
              <option *ngFor="let sexo of sexos" [value]="sexo">{{ sexo }}</option>
            </select>
            <div class="invalid-feedback"
              *ngIf="(submitted || f['funcionarioSexo'].touched) && f['funcionarioSexo'].errors">
              Sexo es requerido
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <label class="form-label">País de Origen <span class="text-danger">*</span></label>
            <select class="form-control si-select" formControlName="funcionarioPaisOrigen"
              [class.is-invalid]="(submitted || f['funcionarioPaisOrigen'].touched) && f['funcionarioPaisOrigen'].errors">
              <option *ngFor="let pais of paisesOrigen" [value]="pais">{{ pais }}</option>
            </select>
            <div class="invalid-feedback"
              *ngIf="(submitted || f['funcionarioPaisOrigen'].touched) && f['funcionarioPaisOrigen'].errors">
              País de origen es requerido
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <label class="form-label">Región <span class="text-danger">*</span></label>
            <select class="form-control si-select" formControlName="funcionarioRegion"
              [class.is-invalid]="(submitted || f['funcionarioRegion'].touched) && f['funcionarioRegion'].errors">
              <option value="">-- Seleccione región --</option>
              <option *ngFor="let region of regiones" [value]="region.codigo">{{region.codigo}}.{{ region.nombre }}
              </option>
            </select>
            <div class="invalid-feedback"
              *ngIf="(submitted || f['funcionarioRegion'].touched) && f['funcionarioRegion'].errors">
              Región es requerida
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <label class="form-label">Comuna <span class="text-danger">*</span></label>
            <select class="form-control si-select" formControlName="funcionarioComuna"
              [class.is-invalid]="(submitted || f['funcionarioComuna'].touched) && f['funcionarioComuna'].errors"
              [disabled]="!f['funcionarioRegion'].value">
              <option value="">-- Seleccione comuna --</option>
              <option *ngFor="let comuna of funcionarioComunas" [value]="comuna.codigo">{{ comuna.codigo
                }}.{{comuna.nombre}}
              </option>
            </select>
            <div class="invalid-feedback"
              *ngIf="(submitted || f['funcionarioComuna'].touched) && f['funcionarioComuna'].errors">
              Comuna es requerida
            </div>
          </div>

          <div class="col-md-12 mb-3">
            <label class="form-label">Dirección Laboral <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="funcionarioDireccionParticular"
              [class.is-invalid]="(submitted || f['funcionarioDireccionParticular'].touched) && f['funcionarioDireccionParticular'].errors"
              placeholder="Calle, número, piso">
            <div class="invalid-feedback"
              *ngIf="(submitted || f['funcionarioDireccionParticular'].touched) && f['funcionarioDireccionParticular'].errors">
              Dirección es requerida
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <label class="form-label">Correo Electrónico Personal <span class="text-danger">*</span></label>
            <input type="email" class="form-control" formControlName="funcionarioCorreoElectronico"
              [class.is-invalid]="(submitted || f['funcionarioCorreoElectronico'].touched) && f['funcionarioCorreoElectronico'].errors"
              placeholder="correo@ejemplo.com">
            <div class="invalid-feedback"
              *ngIf="(submitted || f['funcionarioCorreoElectronico'].touched) && f['funcionarioCorreoElectronico'].errors">
              Correo válido es requerido
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <label class="form-label">Validación de Correo <span class="text-danger">*</span></label>
            <input type="email" class="form-control" formControlName="funcionarioCorreoValidacion"
              [class.is-invalid]="(submitted || f['funcionarioCorreoValidacion'].touched) && f['funcionarioCorreoValidacion'].errors"
              placeholder="Confirme el correo">
            <small class="form-text text-muted">Ingrese el correo nuevamente para confirmar</small>
            <div class="invalid-feedback"
              *ngIf="(submitted || f['funcionarioCorreoValidacion'].touched) && f['funcionarioCorreoValidacion'].errors">
              Confirmación de correo es requerida
            </div>
          </div>

          <div class="col-md-12 mb-3">
            <div class="alert alert-info">
              <i class="bi bi-info-circle me-2"></i>
              <strong>Período de Evaluación (últimos 2 años):</strong>
              <div class="mt-2">
                <p class="mb-1"><strong>Fecha Inicio:</strong> {{ f['fechaInicio'].value | date:'dd/MM/yyyy' }}</p>
                <p class="mb-0"><strong>Fecha Fin:</strong> {{ f['fechaTermino'].value | date:'dd/MM/yyyy' }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- SECCIÓN 4: CONFIRMACIÓN -->
    <div class="card mb-4">
      <div class="card-header bg-primary text-white">
        <h5 class="mb-0">Confirmación de la Solicitud</h5>
      </div>
      <div class="card-body">
        <div class="form-check mb-3">
          <input type="checkbox" class="form-check-input" id="confirmacion" formControlName="confirmacionAutorizacion"
            [class.is-invalid]="(submitted || f['confirmacionAutorizacion'].touched) && f['confirmacionAutorizacion'].errors">
          <label class="form-check-label" for="confirmacion">
            Confirmo que la información ingresada es correcta y autorizo a notificar al correo de la institución
            <span class="text-danger">*</span>
          </label>
          <div class="invalid-feedback d-block"
            *ngIf="(submitted || f['confirmacionAutorizacion'].touched) && f['confirmacionAutorizacion'].errors">
            Debe confirmar la autorización para continuar
          </div>
        </div>
      </div>
    </div>

    <!-- BOTONES DE ACCIÓN -->
    <div class="row mt-4 mb-4">
      <div class="col-12">
        <div class="text-right">
          <button type="button" class="btn btn-secondary mr-2" (click)="onReset()">Limpiar</button>
          <button type="submit" class="btn btn-primary">Continuar</button>
        </div>
      </div>
    </div>
  </form>

  <!-- MODAL DE VISTA PREVIA -->
  <div class="modal fade show d-block" tabindex="-1" role="dialog" *ngIf="showPreviewModal"
    style="background: rgba(0, 0, 0, 0.5); overflow-y: auto;">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white">
          <h5 class="modal-title">Vista Previa de la Solicitud</h5>
          <button type="button" class="close text-white" aria-label="Close" (click)="cerrarVistaPrevia()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body p-0 bg-light">
          <!-- Documento tipo PDF -->
          <div class="pdf-preview m-3 m-md-4">
            <div class="pdf-header">
              <h3>Formulario de Solicitud Inicial</h3>
              <h4>Evaluación de Salud Irrecuperable - Funcionario Público</h4>
            </div>

            <div class="pdf-section">
              <div class="pdf-section-title">1. Datos del Solicitante</div>
              <div class="pdf-row">
                <div class="pdf-col"><strong>RUT:</strong> <span class="pdf-value">{{ form.get('solicitanteRut')?.value
                    }}</span></div>
                <div class="pdf-col"><strong>Teléfono:</strong> <span class="pdf-value">{{
                    form.get('solicitanteTelefono')?.value }}</span></div>
                <div class="pdf-col full-width"><strong>Nombre Completo:</strong> <span class="pdf-value">{{
                    form.get('solicitanteNombre')?.value }} {{ form.get('solicitanteApellidoPaterno')?.value }} {{
                    form.get('solicitanteApellidoMaterno')?.value }}</span></div>
                <div class="pdf-col full-width"><strong>Correo Electrónico:</strong> <span class="pdf-value">{{
                    form.get('solicitanteCorreo')?.value }}</span></div>
              </div>
            </div>

            <div class="pdf-section">
              <div class="pdf-section-title">2. Datos de la Institución</div>
              <div class="pdf-row">
                <div class="pdf-col"><strong>RUT:</strong> <span class="pdf-value">{{ form.get('institucionRut')?.value
                    }}</span></div>
                <div class="pdf-col full-width"><strong>Nombre Institución:</strong> <span class="pdf-value">{{
                    form.get('institucionNombre')?.value }}</span></div>
                <div class="pdf-col full-width"><strong>Jefe Superior:</strong> <span class="pdf-value">{{
                    form.get('jefeNombreCompleto')?.value }}</span></div>
                <div class="pdf-col full-width"><strong>Correo Notificación:</strong> <span class="pdf-value">{{
                    form.get('institucionCorreoNotificacion')?.value }}</span></div>
              </div>
            </div>

            <div class="pdf-section">
              <div class="pdf-section-title">3. Datos del Funcionario a Evaluar</div>
              <div class="pdf-row">
                <div class="pdf-col"><strong>RUT:</strong> <span class="pdf-value">{{ form.get('funcionarioRut')?.value
                    }}</span></div>
                <div class="pdf-col"><strong>Fecha de Nacimiento:</strong> <span class="pdf-value">{{
                    form.get('funcionarioFechaNacimiento')?.value }}</span></div>
                <div class="pdf-col full-width"><strong>Nombre Completo:</strong> <span class="pdf-value">{{
                    form.get('funcionarioNombre')?.value }} {{ form.get('funcionarioApellidoPaterno')?.value }} {{
                    form.get('funcionarioApellidoMaterno')?.value }}</span></div>
                <div class="pdf-col full-width"><strong>Correo Electrónico:</strong> <span class="pdf-value">{{
                    form.get('funcionarioCorreoElectronico')?.value }}</span></div>
                <div class="pdf-col"><strong>Fecha de Inicio:</strong> <span class="pdf-value">{{
                    form.get('fechaInicio')?.value | date:'dd/MM/yyyy' }}</span></div>
                <div class="pdf-col"><strong>Fecha Fin:</strong> <span class="pdf-value">{{
                    form.get('fechaTermino')?.value | date:'dd/MM/yyyy' }}</span></div>
              </div>
            </div>

            <div class="pdf-footer">
              <div class="signature-box">
                Firma Solicitante
              </div>
              <p class="mt-3"><em>Confirmo que la información ingresada en este documento es fidedigna y autorizo su
                  procesamiento.</em></p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="cerrarVistaPrevia()">Volver</button>
          <button type="button" class="btn btn-primary" (click)="confirmSubmit()">Enviar y Firmar Solicitud</button>
        </div>
      </div>
    </div>
  </div>
</div>